import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../portalV2Shared.css';
import './ModalErrorV2.css';

/**
 * Portal V2 error modal — glass / gold UI.
 * Portaled to document.body so it always covers the full viewport
 * (avoids being clipped by transformed / overflow parents in Steps).
 * Classic white bootstrap ModalError stays untouched.
 */
const ModalErrorV2 = ({
    show,
    setShowError,
    ModalErrorTitle = 'Something went wrong',
    ModalErrorDesc = '',
}) => {
    useEffect(() => {
        if (!show) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') setShowError(false);
        };
        document.addEventListener('keydown', onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [show, setShowError]);

    if (!show || typeof document === 'undefined') return null;

    const close = () => setShowError(false);

    return createPortal(
        <div
            className="pv2-modal-error"
            role="dialog"
            aria-modal="true"
            aria-labelledby="pv2-modal-error-title"
        >
            <div
                className="pv2-modal-error__backdrop"
                aria-hidden="true"
                onClick={close}
            />
            <div className="pv2-modal-error__card">
                <div className="pv2-modal-error__head">
                    <div>
                        <p className="pv2-modal-error__eyebrow">Notice</p>
                        <h2
                            id="pv2-modal-error-title"
                            className="pv2-modal-error__title"
                        >
                            {ModalErrorTitle}
                        </h2>
                    </div>
                    <button
                        type="button"
                        className="pv2-modal-error__close"
                        onClick={close}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                {ModalErrorDesc ? (
                    <p className="pv2-modal-error__desc">{ModalErrorDesc}</p>
                ) : null}
                <div className="pv2-modal-error__actions">
                    <button
                        type="button"
                        className="pv2-modal-error__ok"
                        onClick={close}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalErrorV2;
